"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.exportQuotesEpic = void 0;

var _actions = require("./actions");

var _selectors = require("settings-ui-sdk/Quotes/selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var exportQuotesEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.startExport,
  initiatingActionType: _actions.QuotesActionTypes.EXPORT_QUOTES,
  requestActions: _actions.ExportQuotes,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: _selectors.getExportQuotesStatus
}));
exports.exportQuotesEpic = exportQuotesEpic;
var _default = exportQuotesEpic;
exports.default = _default;